export default __webpack_public_path__ + "static/media/desktopHomeImage.89f7cdec.png";